import { ApolloError } from '@apollo/client';

import ComponentOverlay from '../../shared/component-overlay/component-overlay';
import {
  PlayableComponentButton,
  PlayableComponentButtonText,
} from '../../shared/playable-component.style';
import { getInteractiveResponseStudentAnswerCount } from 'approot/activity-builder/classroom/interactive-response/interactive-response-individual-responses.utils';

const InteractiveResponseComponentResponse = ({
  id,
  title,
  label,
  isLoggedIn,
  hasFetchedAnswers,
  error,
  onStart,
}: {
  id: string;
  title?: string | null;
  label: string;
  isLoggedIn: boolean;
  hasFetchedAnswers: boolean;
  error?: ApolloError;
  onStart: () => void;
}) => {
  return isLoggedIn ? (
    <ComponentOverlay
      ariaLabel={`Click to complete the interactive: ${title}`}
      componentId={id}
      hasFetchedAnswers={hasFetchedAnswers}
      error={error}
      onClick={onStart}
      getActiveStudentAnswerCount={answers =>
        getInteractiveResponseStudentAnswerCount(answers)
      }
    />
  ) : (
    <PlayableComponentButton
      type="button"
      aria-label={`Click to start ${label} response: ${title}`}
      onClick={onStart}
      data-selector="btn-start"
    >
      <PlayableComponentButtonText>Start</PlayableComponentButtonText>
    </PlayableComponentButton>
  );
};

export default InteractiveResponseComponentResponse;
